import { RouteObject } from 'react-router-dom';
import { ArticlePageLayout } from 'app/components/layouts/ArticlePageLayout';

import TailorLanding from './screens/TailorLanding';
import TailorSearch from './screens/TailorSearch';
import TailorArticle from './screens/TailorArticle';
import TailorInfo from './screens/TailorInfo';
import TailorCategory from './screens/TailorCategory';
import { RootLayout } from '../../components/layouts/RootLayout';
import TailorInterstitial from './screens/TailorInterstitial';

const tailorRoutes: RouteObject[] = [
  {
    path: '/tailor',
    element: <RootLayout />,
    children: [
      {
        path: '/tailor',
        element: <TailorLanding />,
      },
      {
        path: 'search',
        element: <TailorSearch />,
      },
      {
        path: 'category/:category',
        element: <TailorCategory />,
      },
    ],
  },
  {
    path: '/tailor',
    element: <ArticlePageLayout />,
    children: [
      {
        path: 'article/:articleId?',
        element: <TailorArticle />,
      },
    ],
  },
  {
    path: '/tailor',
    element: (
      <RootLayout
        hideImportantInformation
        hideContactForm
      />
    ),
    children: [
      {
        path: 'info/:type',
        element: <TailorInfo />,
      },
      {
        path: 'interstitial',
        element: <TailorInterstitial />,
      },
    ],
  },
];

export default tailorRoutes;
